import SiteHeader from "@/components/common/SiteHeader";
import { createFileRoute } from "@tanstack/react-router";
import React from "react";

const DataUsage = () => (
  <div className="flex flex-col w-full">
    <SiteHeader header="Utility Data Usage Policy" />
    <div className="px-10 py-8">
      <div className="pb-4">
        <p className="font-bold">Last updated: April 2, 2024</p>
        <h2>Introduction</h2>
        <p>
          {`This Utility Data Usage Policy ("Policy") governs the handling,
          processing, and storage of confidential customer information
          ("Confidential Information") by Carbon Clear ("we", "us", or "our") in
          providing our services ("Services"). By utilizing our Services,
          customers ("you") consent to the practices described in this Policy.`}
        </p>
      </div>

      <div className="py-4">
        <h2>Customer Consent</h2>
        <p>
          We adhere to the federal, state, and local laws, and regulations in
          obtaining informed consent from customers before requesting
          Confidential Information from utility providers. Your consent is
          required for us to access your utility data and may be revoked through
          the utility provider at any time.{" "}
        </p>
      </div>

      <div className="py-4">
        <h2>Confidentiality</h2>
        <p>We commit to:</p>
        <ul className="flex flex-col gap-2">
          <li>
            Maintaining all Confidential Information in secure data storage
            facilities.{" "}
          </li>
          <li>
            Not disclosing Confidential Information to third parties, except as
            explicitly permitted under this Policy or by your consent.
          </li>
          <li>
            Processing Confidential Information solely for the purposes of
            delivering the Services, as authorized by you.
          </li>
          <li>
            Storing Confidential Information securely and limiting its
            reproduction.
          </li>
        </ul>
      </div>

      <div className="py-4">
        <h2>Return/Destruction of Information</h2>
        <p>
          Upon written request from the utility provider or upon revocation of
          your consent, we will:
        </p>
        <ul className="flex flex-col gap-2">
          <li>Stop processing your utility information.</li>
          <li>
            Destroy all copies of your utility information in our possession
            within 30 days, in accordance with our security and data protection
            policies.
          </li>
        </ul>
      </div>

      <div className="py-4">
        <h2>Use of Derivative Data</h2>
        <p>
          We will not create or maintain data derived from your Confidential
          Information, except as necessary to provide our Services to the user,
          as permitted by law, or with your explicit consent. This does not
          include data necessary for legitimate business purposes.
        </p>
      </div>

      <div className="py-4">
        <h2>Compliance with Laws</h2>
        <p>
          We will comply with all applicable privacy and security laws, ensuring
          that our handling of your Confidential Information does not place the
          utility provider in violation of any laws.
        </p>
      </div>

      <div className="py-4">
        <h2>Data Security</h2>
        <p>
          We ensure the security and encryption of all Confidential Information
          during storage and transmission, in compliance with industry standards
          and legal requirements.{" "}
        </p>
      </div>

      <div className="py-4">
        <h2>Contact Us</h2>
        <p>
          For questions or concerns regarding this Utility Data Usage Policy,
          please contact us at{" "}
          <a href="mailto:support@getcodeclear.com">
            support@getcodeclear.com
          </a>
          .
        </p>
      </div>
    </div>
  </div>
);
export const Route = createFileRoute("/policies/data_usage")({
  component: DataUsage,
});
